<template>
    <div class="cmp-wrapper">
        <basic-container>
            <el-form :model="formData" inline ref="mainQuery">
                <el-form-item label="商品名称">
                    <el-input style="margin-left:10px;" v-model="formData.goodsName" placeholder="请输入商品名称"/>
                </el-form-item>
                <el-form-item label="SKUID">
                    <el-input style="margin-left:10px;" v-model="formData.skuIdStr" placeholder="请输入SKUID"/>
                </el-form-item>
                <el-form-item label="SSUID">
                    <el-input style="margin-left:10px;" v-model="formData.ssuIdStr" placeholder="请输入SSUID"/>
                </el-form-item>
                <el-form-item label="门店信息">
                    <el-input style="margin-left:10px;" v-model="formData.storeInfoStr" placeholder="请输入门店信息"/>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon" type="primary" @click="onRelationSearch" style="margin:0 10px">查询</el-button>
                    <el-button icon="el-icon-plus" type="primary" @click="onAddRelations" style="margin:0 10px">新建</el-button>
                    <el-button icon="el-icon" type="primary" @click="onDelRelations" style="margin:0 10px">删除</el-button>
                </el-form-item>
            </el-form>
            
            <el-table v-loading="loading" :data="tableData" ref="multiTable">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="关系名称" prop="relationName" align="center"></el-table-column>
                <el-table-column label="SKUID-SSUID" prop="skuSsuIdStr" align="center"></el-table-column>
                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
                <el-table-column label="下单后规则失效" prop="goodsName" align="center">
                    <template v-slot="{ row }">
                        <el-switch
                            v-model="row.invalidStatus"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否"
                            :active-value="1"
                            :inactive-value="0"
                            @change="changes(row)"
                            >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="门店列表" align="center" width="100">
                    <template v-slot="{ row }">
                        <el-button class="operateBtn" type="text" @click="handleStoreDetail(row)">查看详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="relationStatusStr" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="150">
                  <template v-slot="{row}">
                    <el-button class="operateBtn" type="text" @click="handleAddStores(row)">新增门店</el-button>
                    <el-button class="operateBtn" type="text" @click="handleDelStores(row)">删除门店</el-button>
                    <el-button class="operateBtn" type="text" @click="handleUpdateRelationStatus(row)" >
                        <span v-text="row.relationEnable ? '停用' :'启用'"></span>
                    </el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="footer">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formData.pageNum"
                :page-size.sync="formData.pageSize"
                :page-sizes="[20, 30, 40, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total.sync="total"
                background
                ></el-pagination>
            </div>
        </basic-container>
        <el-dialog :visible.sync="relationStoresDetailFormData.modalShow" title="门店详情">
            <h3 style="text-align: center; margin: 5px 0;">已选择商品</h3>
            <el-table :data="storeDetailsSkuSsuData" ref="storeDetailsSkuSsuDataTable">
                <el-table-column label="SKUID-SSUID" prop="skuSsuIdStr" align="center"></el-table-column>
                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
            </el-table>
            <h3 style="text-align: center; margin: 5px 0;">已选择门店</h3>
            <el-form :model="relationStoresDetailFormData" inline>
                <el-form-item label="门店名称">
                    <el-input style="margin-left:10px;" v-model="relationStoresDetailFormData.storeName" placeholder="请输入门店名称"/>
                </el-form-item>
                <el-form-item label="门店ID">
                    <el-input style="margin-left:10px;" v-model="relationStoresDetailFormData.storeIdsStr" placeholder="请输入门店ID"/>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon" type="primary" @click="onStoreDetailsSearch" style="margin:0 10px">查询</el-button>
                    <el-button icon="el-icon" type="primary" @click="onStoreDetailsReset" style="margin:0 10px">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="storeDetailsData" max-height="400px">
                <el-table-column label="门店ID" prop="storeId" align="center"></el-table-column>
                <el-table-column label="门店名称" prop="storeName" align="center"></el-table-column>
            </el-table>
            <div class="footer">
                    <el-pagination
                    @size-change="handleStoreDetailSizeChange"
                    @current-change="handleStoreDetailCurrentChange"
                    :current-page.sync="relationStoresDetailFormData.pageNum"
                    :page-size.sync="relationStoresDetailFormData.pageSize"
                    :page-sizes="[20, 30, 40, 50]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total.sync="storeDetailTotal"
                    background
                    ></el-pagination>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="deleteStoresFormData.modalShow" title="删除门店">
            <h3 style="text-align: center; margin: 5px 0;">已选择商品</h3>
            <el-table :data="deleteStoreSkuSsuData" ref="deleteStoreSkuSsuDataTable">
                <el-table-column label="SKUID-SSUID" prop="skuSsuIdStr" align="center"></el-table-column>
                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
            </el-table>
            <h3 style="text-align: center; margin: 5px 0;">已选择门店</h3>
            <el-form :model="deleteStoresFormData" inline>
                <el-form-item label="门店名称">
                    <el-input style="margin-left:10px;" v-model="deleteStoresFormData.storeName" placeholder="请输入门店名称"/>
                </el-form-item>
                <el-form-item label="门店ID">
                    <el-input style="margin-left:10px;" v-model="deleteStoresFormData.storeIdsStr" placeholder="请输入门店ID"/>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon" type="primary" @click="onDeleteStoreDetailsSearch" style="margin:0 10px">查询</el-button>
                    <el-button icon="el-icon" type="primary" @click="onDeleteStoreDetailsReset" style="margin:0 10px">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="deleteStoreDetailsData" ref="deleteStoreDetailTable" max-height="400px">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="门店ID" prop="storeId" align="center"></el-table-column>
                <el-table-column label="门店名称" prop="storeName" align="center"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="text" @click="onDeleteStoreDetailsClose">取消</el-button>
                <el-button type="primary" @click="onDeleteStoreDetails">确认删除</el-button>
            </div>
            <div class="footer">
                    <el-pagination
                    @size-change="handleDeleteStoreDetailSizeChange"
                    @current-change="handleDeleteStoreDetailCurrentChange"
                    :current-page.sync="deleteStoresFormData.pageNum"
                    :page-size.sync="deleteStoresFormData.pageSize"
                    :page-sizes="[20, 30, 40, 50]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total.sync="deleteStoreDetailTotal"
                    background
                    ></el-pagination>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="addStoresFormData.modalShow" title="新增门店">
            <h3 style="text-align: center; margin: 5px 0;">已选择商品</h3>
            <el-table :data="addStoreSkuSsuData" ref="addStoreSkuSsuDataTable">
                <el-table-column label="SKUID-SSUID" prop="skuSsuIdStr" align="center"></el-table-column>
                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
            </el-table>
            <h3 style="text-align: center; margin: 5px 0;">已选择门店</h3>
            <el-form :model="addStoresFormData" inline>
                <el-form-item label="门店名称">
                    <el-input style="margin-left:10px;" v-model="addStoresFormData.storeName" placeholder="请输入门店名称"/>
                </el-form-item>
                <el-form-item label="门店ID">
                    <el-input style="margin-left:10px;" v-model="addStoresFormData.storeIdsStr" placeholder="请输入门店ID"/>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon" type="primary" @click="onAddStoreDetailsSearch" style="margin:0 10px">查询</el-button>
                    <el-button icon="el-icon" type="primary" @click="onAddStoreDetailsReset" style="margin:0 10px">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="addStoreDetailsData" ref="addStoreDetailTable" max-height="400px">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="门店ID" prop="storeId" align="center"></el-table-column>
                <el-table-column label="门店名称" prop="storeName" align="center"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="text" @click="onAddStoreDetailsClose">取消</el-button>
                <el-button type="primary" @click="onAddStoreDetails">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="createRelationFormData.modalFirstShow" title="新建必采关系">
            <el-form :model="createRelationFormData" inline>
                <el-form-item label="关系名称">
                    <el-input v-model="createRelationFormData.relationName" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onCreateNext">下一步</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="createRelationFormData.modalSecondShow" title="新建必采关系">

            <h3 style="text-align: center; margin: 5px 0;">选择商品</h3>
            <el-form :model="getGoodsCandidateFormData" inline>
                <el-form-item label="商品名称">
                    <el-input style="margin-left:10px;" v-model="getGoodsCandidateFormData.goodsName" placeholder="请输入商品名称"/>
                </el-form-item>
                <el-form-item label="SKUID">
                    <el-input style="margin-left:10px;" v-model="getGoodsCandidateFormData.skuIdStr" placeholder="请输入SKUID"/>
                </el-form-item>
                <el-form-item label="SSUID">
                    <el-input style="margin-left:10px;" v-model="getGoodsCandidateFormData.ssuIdStr" placeholder="请输入SSUID"/>
                </el-form-item>
                <el-form-item label="下单后规则失效">
                    <el-switch
                        v-model="getGoodsCandidateFormData.invalidStatus"
                        style="margin-left:10px;" 
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="是"
                        inactive-text="否"
                        :active-value="1"
                        :inactive-value="0"
                        >
                    </el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon" type="primary" @click="onCreateGoodsCandidateSearch" style="margin:0 10px">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="goodsCandidateData" ref="createGoodsMultiTable" max-height="300px">
                <el-table-column label="SKUID" prop="skuId" align="center"></el-table-column>
                <el-table-column label="SSUID" prop="ssuId" align="center"></el-table-column>
                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
                <el-table-column type="selection" :selectable="goodsSelectable" width="55" align="center"></el-table-column>
            </el-table>

            <br/>

            <h3 style="text-align: center; margin: 5px 0;">选择门店</h3>
            <el-form :model="getStoreCandidateFormData" inline>
                <el-form-item label="门店名称">
                    <el-input style="margin-left:10px;" v-model="getStoreCandidateFormData.storeName" placeholder="请输入门店名称"/>
                </el-form-item>
                <el-form-item label="门店ID">
                    <el-input style="margin-left:10px;" v-model="getStoreCandidateFormData.storeIdsStr" placeholder="多个ID用逗号隔开"/>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon" type="primary" @click="onCreateStoreCandidateSearch" style="margin:0 10px">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="storeCandidateData" ref="createStoreMultiTable" max-height="400px">
                <el-table-column label="门店ID" prop="storeId" align="center"></el-table-column>
                <el-table-column label="门店名称" prop="storeName" align="center"></el-table-column>
                <el-table-column type="selection" width="55" align="center"></el-table-column>
            </el-table>
            
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onCreatePre">上一步</el-button>
                <el-button type="primary" @click="onCreateConfirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { param, getBaseUrl } from "@/framework/utils/tools";
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            formData: {
                skuIdStr: "",
                ssuIdStr: "",
                storeInfoStr: "",
                goodsName: "",
                pageNum: 1,
                pageSize: 20
            },
            total: 0,
            loading: false,
            tableData: [],
            relationStoresDetailFormData: {
                modalShow: false,
                storeName: "",
                storeIdsStr: "",
                ssuIdStr: "",
                pageNum: 1,
                pageSize: 20
            },
            storeDetailsSkuSsuData: [],
            storeDetailsData: [],
            storeDetailTotal: 0,
            deleteStoresFormData: {
                modalShow: false,
                storeName: "",
                storeIdsStr: "",
                ssuIdStr: "",
                pageNum: 1,
                pageSize: 20
            },
            deleteStoreSkuSsuData: [],
            deleteStoreDetailsData: [],
            deleteStoreDetailTotal: 0,
            addStoresFormData: {
                modalShow: false,
                storeName: "",
                storeIdsStr: ""
            },
            addStoreSkuSsuData: [],
            addStoreDetailsData: [],
            createRelationFormData: {
                modalFirstShow: false,
                modalSecondShow: false,
                relationName: ""
            },
            getStoreCandidateFormData: {
                storeName: "",
                storeIdsStr: ""
            },
            getGoodsCandidateFormData: {
                goodsName: "",
                skuIdStr: "",
                ssuIdStr: "",
                invalidStatus: 0
            },
            
            goodsCandidateData: [],
            storeCandidateData: []
        };
    },
    async mounted() {
        await this.initPageData();
    },
    methods: {
        handleCurrentChange() {
            this.initPageData();
        },
        handleSizeChange() {
            formData.pageNum = 1;
            this.initPageData();
        },
        onStoreDetailsSearch() {
            this.getStoreDetailsData();
        },
        onStoreDetailsReset() {
            this.relationStoresDetailFormData.storeName = "";
            this.relationStoresDetailFormData.storeIdsStr = "";
        },
        handleStoreDetailCurrentChange() {
            this.getStoreDetailsData();
        },
        handleStoreDetailSizeChange() {
            this.relationStoresDetailFormData.pageNum = 1;
            this.getStoreDetailsData();
        },

        onDeleteStoreDetailsSearch() {
            this.getDeleteStoreDetailsData();
        },
        onDeleteStoreDetailsReset() {
            this.deleteStoresFormData.storeName = "";
            this.deleteStoresFormData.storeIdsStr = "";
        },
        onDeleteStoreDetailsClose() {
            this.deleteStoresFormData.modalShow = false;
        }, 
        changes(row){
            console.log('val',row)
            _api.bc.bcUpdateInvalidStatus({id:row.id,invalidStatus:row.invalidStatus}).then(()=>{
                this.initPageData()
            })
        },
        async onDeleteStoreDetails() {
            const storeRows = this.$refs.deleteStoreDetailTable.selection;
            const ssuId = this.deleteStoreSkuSsuData[0].ssuId;
            if (!storeRows || storeRows.length === 0) {
                this.$message.warning("至少选择一个门店");
                return;
            }
             try {
                const { ret, error } = await _api.bc.deleteRelationBindStores({
                    ssuId: ssuId,
                    storeIds: storeRows.map(item => item.storeId)
                });
                if (ret) {
                    this.deleteStoresFormData.modalShow = false;
                    await this.initPageData();
                } else {
                    this.$message.warning(error  );
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
        handleDeleteStoreDetailSizeChange() {
            this.formData.pageNum = 1;
            this.getDeleteStoreDetailsData();
        }, 
        handleDeleteStoreDetailCurrentChange() {
            this.getDeleteStoreDetailsData();
        },

        onAddStoreDetailsSearch() {
            this.getAddStoreDetailsData();
        },
        onAddStoreDetailsReset() {
            this.addStoresFormData.storeName = "";
            this.addStoresFormData.storeIdsStr = "";
        },
        onAddStoreDetailsClose() {
            this.addStoresFormData.modalShow = false;
        },
        async onAddStoreDetails() {
            const storeRows = this.$refs.addStoreDetailTable.selection;
            const ssuId = this.addStoreSkuSsuData[0].ssuId;
            if (!storeRows || storeRows.length === 0) {
                this.$message.warning("至少选择一个门店");
                return;
            }
            try {
                const { ret, error } = await _api.bc.bindStores2Relation({
                    ssuId: ssuId,
                    storeIds: storeRows.map(item => item.storeId)
                });
                if (ret) {
                    this.addStoresFormData.modalShow = false;
                    await this.initPageData();
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
        onRelationSearch() {
            this.initPageData();
        },
        onAddRelations() {
            this.createRelationFormData.relationName = "";
            this.getGoodsCandidateFormData.goodsName = "";
            this.getGoodsCandidateFormData.skuIdStr = "";
            this.getGoodsCandidateFormData.ssuIdStr = "";
            this.getGoodsCandidateFormData.invalidStatus = 0;
            this.getStoreCandidateFormData.storeName = ""; 
            this.getStoreCandidateFormData.storeIdsStr = "";
            this.goodsCandidateData = [];
            this.storeCandidateData = [];
            this.createRelationFormData.modalFirstShow = true;
        },
        onCreateNext() {
            let bcRelationName = this.createRelationFormData.relationName;
            if (!bcRelationName || !bcRelationName.trim()) {
                this.$message.warning("关系名称不能为空");
                return;
            }
            this.createRelationFormData.modalFirstShow = false;
            this.createRelationFormData.modalSecondShow = true;
        },
        onCreatePre() {
            this.createRelationFormData.modalSecondShow = false;
            this.createRelationFormData.modalFirstShow = true;
        },
        async onCreateGoodsCandidateSearch() {
            try {
                if (!this.getGoodsCandidateFormData.goodsName && !this.getGoodsCandidateFormData.skuIdStr && !this.getGoodsCandidateFormData.ssuIdStr) {
                    this.$message.warning("商品名称,SKUID,SSUID不能同时为空")
                    return;
                }
                const { ret, error, data } = await _api.bc.queryCandidateGoodsItems(this.getGoodsCandidateFormData);
                if (ret) {
                    this.goodsCandidateData = data || [];
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
        async onCreateStoreCandidateSearch() {
            try {
                if (!this.getStoreCandidateFormData.storeName && !this.getStoreCandidateFormData.storeIdsStr) {
                    this.$message.warning("门店名称,门店ID不能同时为空")
                    return;
                }
                const { ret, error, data } = await _api.bc.queryCandidateStoreItems(this.getStoreCandidateFormData);
                if (ret) {
                    this.storeCandidateData = data || [];
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
        async onCreateConfirm() {
            const relationName = this.createRelationFormData.relationName;
            const invalidStatus =  this.getGoodsCandidateFormData.invalidStatus;
            if (!relationName || !relationName.trim()) {
                this.$message.warning("关系名称不能为空");
                return;
            }
            const goodsRows = this.$refs.createGoodsMultiTable.selection;
            if (!goodsRows || goodsRows.length === 0) {
                this.$message.warning("至少选择一个商品");
                return;
            } 
            const storeRows = this.$refs.createStoreMultiTable.selection;
             if (!storeRows || storeRows.length === 0) {
                this.$message.warning("至少选择一个门店");
                return;
            }
            try {
                const { ret, error } = await _api.bc.createBCRelations({
                    relationName: relationName,
                    invalidStatus: invalidStatus,
                    ssuIds: goodsRows.map(item => item.ssuId),
                    storeIds: storeRows.map(item => item.storeId)
                });
                if (ret) {
                    this.createRelationFormData.modalSecondShow = false;
                    await this.initPageData();
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
       
        async onDelRelations() {
            const storeRows = this.$refs.multiTable.selection;
            if (!storeRows || storeRows.length === 0) {
                this.$message.warning("至少选择一个必采关系");
                return;
            }
             this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                try {
                    this.loading = true;
                    const { ret, error } = await _api.bc.deleteBCRelations({
                        ssuIds: storeRows.map(item => item.ssuId)
                    });
                    if (ret) {
                        await this.initPageData();
                    } else {
                        this.$message.warning(error);
                    }
                } catch (e) {
                    console.log(e);
                    this.$message.error(e);
                } finally {
                    this.loading = false;
                }
            }).catch(() => {
            });
        },
        handleStoreDetail(row) {
            this.storeDetailsSkuSsuData = [{
                skuSsuIdStr: row.skuId + "-" + row.ssuId,
                skuId: row.skuId,
                ssuId: row.ssuId,
                goodsName: row.goodsName
            }];
            this.relationStoresDetailFormData.storeName = "";
            this.relationStoresDetailFormData.storeIdsStr = "";
            this.relationStoresDetailFormData.pageSize = 20;
            this.relationStoresDetailFormData.pageNum = 1;
            this.relationStoresDetailFormData.modalShow = true;
            this.getStoreDetailsData();
        },
        handleAddStores(row) {
            this.addStoreSkuSsuData = [{
                skuSsuIdStr: row.skuId + "-" + row.ssuId,
                skuId: row.skuId,
                ssuId: row.ssuId,
                goodsName: row.goodsName
            }];
            this.addStoresFormData.storeName = "";
            this.addStoresFormData.storeIdsStr = "";
            this.addStoreDetailsData = [];
            this.addStoresFormData.modalShow = true;
        },
        goodsSelectable(row, index) {
            return row.selectable;
        },
        handleDelStores(row) {
            this.deleteStoreSkuSsuData = [{
                skuSsuIdStr: row.skuId + "-" + row.ssuId,
                skuId: row.skuId,
                ssuId: row.ssuId,
                goodsName: row.goodsName
            }];
            this.deleteStoresFormData.storeName = "";
            this.deleteStoresFormData.storeIdsStr = "";
            this.deleteStoresFormData.pageSize = 20;
            this.deleteStoresFormData.pageNum = 1;
            this.deleteStoresFormData.modalShow = true;
            this.getDeleteStoreDetailsData();
        }, 
        async handleUpdateRelationStatus(row) {
             try {
                const { ret, error } = await _api.bc.updateRelationStatus({
                    ssuId: row.ssuId,
                    relationStatus: row.relationEnable ? 0 : 1
                });
                if (ret) {
                    await this.initPageData();
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
        async initPageData() {
            this.loading = true;
            try {
                const { ret, error, data } = await _api.bc.relationPageQuery(this.formData);
                if (ret) {
                    if (!data) {
                        return;
                    }
                    const { items, totalCount } = data;
                    this.total = totalCount;
                    this.tableData = items || [];
                    this.tableData.forEach(item => {
                        item.skuSsuIdStr = item.skuId + "-" + item.ssuId;
                        item.relationStatusStr = item.relationEnable ? "启用" : "停用";
                    });
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            } finally {
                this.loading = false;
            }
        },
        async getStoreDetailsData() {
            try {
                this.relationStoresDetailFormData.ssuIdStr = this.storeDetailsSkuSsuData[0].ssuId;
                const { ret, error, data } = await _api.bc.relationStorePageQuery(this.relationStoresDetailFormData);
                if (ret) {
                    if (!data) {
                        return;
                    }
                    const { items, totalCount } = data;
                    this.storeDetailTotal = totalCount;
                    this.storeDetailsData = items || [];
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
        async getDeleteStoreDetailsData() {
            try {
                this.deleteStoresFormData.ssuIdStr = this.deleteStoreSkuSsuData[0].ssuId;
                const { ret, error, data } = await _api.bc.relationStorePageQuery(this.deleteStoresFormData);
                if (ret) {
                    if (!data) {
                        return;
                    }
                    const { items, totalCount } = data;
                    this.deleteStoreDetailTotal = totalCount;
                    this.deleteStoreDetailsData = items || [];
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        },
        async getAddStoreDetailsData() {
            try {
                const { ret, error, data } = await _api.bc.queryCandidateStoreItems(this.addStoresFormData);
                if (ret) {
                    if (!data) {
                        return;
                    }
                    this.addStoreDetailsData = data || [];
                } else {
                    this.$message.warning(error);
                }
            } catch (e) {
                console.log(e);
                this.$message.error(e);
            }
        }
    }
};
</script>
